/* eslint-disable dot-notation */
import axios from 'axios';

const companiesHouseClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    ENV: process.env.VUE_APP_ENV,
    APIKey: process.env.VUE_APP_COMPANIES_HOUSE_API_KEY
  }
});

export default {
  get (url) {
    return companiesHouseClient.get(url);
  }
};
